/* Chess4pro · tanda 36 regalo-qr (aprobada por Pol 03/11): la página que abre el QR de la nota de regalo (sections/c4p-giftreveal).
   Todo sale del enlace (#o=&to=&fr=&m=; tras #, así no llega al servidor); se limpia y se pinta con textContent. Sin dependencias (usa C4PBoard de c4p-t6.js). */
(() => {
  if (window.__c4pT26) return; window.__c4pT26 = true;
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fill = (s, o) => String(s || '').replace(/\{(\w+)\}/g, (m, k) => (o[k] != null ? o[k] : m));
  const name = (s) => String(s || '').normalize('NFC').replace(/[^\p{L}\p{N} .'’-]/gu, '').replace(/\s+/g, ' ').trim().slice(0, 30);
  const text = (s) => String(s || '').normalize('NFC').replace(/[\u0000-\u001f\u007f-\u009f<>{}\[\]\\|^`~=_*]/g, '').replace(/[^\p{L}\p{N}\p{M} .,;:!?¡¿'’"“”«»()&@#%+\/€$£–—-]/gu, '').replace(/\s+/g, ' ').trim().slice(0, 160);
  const init = () => document.querySelectorAll('.c4p-gr:not([data-on])').forEach((sec) => {
    sec.dataset.on = '1';
    let T = {}; try { T = JSON.parse(sec.dataset.i18n || '{}'); } catch (e) {}
    let D = []; try { D = JSON.parse(sec.querySelector('.c4p-gr__data').textContent); } catch (e) {}
    const $ = (q) => sec.querySelector(q), q = new URLSearchParams(location.hash.length > 1 ? location.hash.slice(1) : location.search); /* el enlace usa # para que los nombres y el mensaje no lleguen al servidor */
    const o = String(q.get('o') || '').toLowerCase().replace(/[^a-z0-9-]/g, '').slice(0, 80);
    const m = o && D.find((x) => x.h === o + '-chess-mug-buy' || x.h === o + '-mug-buy' || x.h === o);
    const E = window.C4PBoard;
    if (!m || !E) { $('.c4p-gr__bd').hidden = true; $('.c4p-gr__none').hidden = false; return; }
    const to = name(q.get('to')), fr = name(q.get('fr')), msg = text(q.get('m'));
    if (to) $('.c4p-gr__to').textContent = to;
    const st = E.steps(m.u), san = String(m.l).trim().split(/\s+/);
    const bd = new E.Board($('.c4p-gr__bd')), ln = $('.c4p-gr__ln'), end = $('.c4p-gr__end'), go = $('.c4p-gr__go');
    $('.c4p-gr__op').textContent = m.n;
    const mEl = $('.c4p-gr__msg'); mEl.textContent = msg ? '“' + msg + '”' : ''; mEl.hidden = !msg;
    const fEl = $('.c4p-gr__fr'); fEl.textContent = fr ? fill(T.from, { f: fr }) : ''; fEl.hidden = !fr;
    const see = $('.c4p-gr__see'); see.href = m.url;
    const last = st[st.length - 1];
    const final = () => { bd.stop(); bd.set(last.b, last.f, last.t); ln.textContent = san.join(' '); end.hidden = false; go.hidden = true; };
    const play = () => { end.hidden = true; go.hidden = true; ln.textContent = '';
      if (reduce()) { final(); return; }
      bd.play(st, 850, (i) => { ln.textContent = san.slice(0, i + 1).join(' '); }, () => { end.hidden = false; });
    };
    bd.set(E.parse(E.START));
    if (reduce()) final(); else { go.hidden = false; go.addEventListener('click', play); }
    $('.c4p-gr__again').addEventListener('click', play);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
